import { render, staticRenderFns } from "./PreviewFakturPajak.vue?vue&type=template&id=60ec6ac0"
import script from "./PreviewFakturPajak.vue?vue&type=script&lang=js"
export * from "./PreviewFakturPajak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports